module.exports = __webpack_public_path__ + "img/header2.c03e3156.jpg";